import React, { useState, useEffect, useRef } from 'react'
import lottie from 'lottie-web'

const defaultStyle = {
	position: 'fixed',	
	top: '0.75rem',
	right: '0.75rem',
	width: '2.25rem',
	height: '2.25rem'
}

export default function AudioButton(props) {
	const soundLottie = useRef()
	
	const lottieContainer = useRef()
	const [soundState, setSoundState] = useState(true)

	useEffect(() => {		
        soundLottie.current = lottie.loadAnimation({           
            container: lottieContainer.current,      
            loop: false,
            autoplay: false,      
            animationData: require('../../assets/btn_audio.json')
		})
		soundLottie.current.playSegments([0,28], true)
	}, [])


	useEffect(() => {			
		if (soundState) {						
			soundLottie.current.playSegments([0,28], true);
		} else {
			soundLottie.current.playSegments([28,43], true);			
		}
	}, [soundState])

	const toggleSoundState = () => {
		setSoundState((prevState) => !prevState)
		props.toggleSound()
	}

	return (
		<div style={defaultStyle} ref={lottieContainer} onClick={toggleSoundState}/>					
	)
};